import { memo } from "react";
import * as Styled from "./Table.styles";
import TableAction from "./TableAction";
import TableFilters from "./TableFilters";
import TableFooter from "./TableFooter";
import TableHead from "./TableHead";
import TablePlaceholder from "./TablePlaceholder";
import TableRows from "./TableRows";
import { TableProps } from "./types";
import useTableHook from "./useTableHook";
import useTableSelectHook from "./useTableSelectHook";

const Table = ({
  onRowClick,
  columns,
  data,
  id = "item_id",
  disableSort = false,
  disableFilter = false,
  disableAction = false,
  disablePagination = false,
  selectableRows = false,
  hideActionsMenu = false,
  onActiveClick,
  onDeActiveClick,
  onDeFavouriteClick,
  onDeTrashClick,
  onDelete,
  onFavouriteClick,
  onHiddenClick,
  onVisibleClick,
  additionalHTML,
  tableName,
  isPending,
  onRowsStyling,
  filterRoutes,
  customActions,
  disabledActionForRow,
  loseSelectOnDataChange = true,
}: TableProps) => {
  const { rows } = useTableHook({ columns, data, id, onRowsStyling });
  const {
    setGroupActive,
    isGroupActive,
    handleSet,
    ids,
    isActive,
    setAll,
    isAllActived,
  } = useTableSelectHook({
    id,
    data,
    loseSelectOnDataChange,
  });
  return (
    <>
      {!disableAction && !hideActionsMenu && (
        <TableAction
          onDeActiveClick={
            onDeActiveClick ? () => onDeActiveClick(ids) : undefined
          }
          onActiveClick={onActiveClick ? () => onActiveClick(ids) : undefined}
          onTrashClick={onDelete ? () => onDelete(ids) : undefined}
          onDeTrashClick={
            onDeTrashClick ? () => onDeTrashClick(ids) : undefined
          }
          onFavouriteClick={
            onFavouriteClick ? () => onFavouriteClick(ids) : undefined
          }
          onDeFavouriteClick={
            onDeFavouriteClick ? () => onDeFavouriteClick(ids) : undefined
          }
          onVisibleClick={
            onVisibleClick ? () => onVisibleClick(ids) : undefined
          }
          onHiddenClick={onHiddenClick ? () => onHiddenClick(ids) : undefined}
          customActions={customActions}
          ids={ids}
          show={ids.length !== 0}
        />
      )}

      <TableFilters
        filterRoutes={filterRoutes}
        disableFilter={disableFilter}
        additionalHTML={additionalHTML}
        tableName={tableName}
        columns={columns}
      />
      <Styled.TableContainer>
        <Styled.Table>
          <TableHead
            isAllActived={isAllActived}
            setAll={() => setAll()}
            disableAction={disableAction}
            disableSort={disableSort}
            tableName={tableName}
            columns={columns}
          />
          <TablePlaceholder
            isVisible={isPending}
            x={
              columns.filter((column) => !column.disable).length +
              (disableAction ? 0 : 1)
            }
            y={data.length}
          />
          <Styled.TableBody isVisible={!isPending}>
            <TableRows
              setGroupActive={setGroupActive}
              isGroupActive={isGroupActive}
              selectableRows={selectableRows}
              onRowsStyling={onRowsStyling}
              isActive={isActive}
              handleSet={handleSet}
              disableAction={disableAction}
              disabledActionForRow={disabledActionForRow}
              id={id}
              onRowClick={onRowClick}
              data={data}
              rows={rows}
            />
          </Styled.TableBody>
        </Styled.Table>
      </Styled.TableContainer>
      {!disablePagination && (
        <TableFooter
          tableName={tableName}
          nextDisabled={isPending || data.length === 0}
        />
      )}
    </>
  );
};

export default memo(Table);
